export default {
    namespaced: true,

    state: {
        shouldRefreshViewTestComponent: false,
        shouldRefreshNotifications: false,
        shouldRefreshPatientTestsComponent: false
    },

    getters: {
        GetShouldRefreshNotifications(state) {
            return state.shouldRefreshNotifications
        },
        GetShouldRefreshViewTestComponent (state) {
            return state.shouldRefreshViewTestComponent
        },
        GetShouldRefreshPatientTestsComponent (state) {
            return state.shouldRefreshPatientTestsComponent
        }
    },

    mutations: {
        SET_SHOULD_REFRESH(state, data) {
            state.shouldRefreshNotifications = data
        },
        SET_SHOULD_REFRESH_VIEW_TEST_COMPONENT (state, data) {
            state.shouldRefreshViewTestComponent = data
        },
        SET_SHOULD_REFRESH_PATIENT_TESTS_COMPONENT (state, data) {
            state.shouldRefreshPatientTestsComponent = data
        }
    },

    actions: {
        SetShouldRefreshNotifications({commit}, value) {
            commit('SET_SHOULD_REFRESH', value)
        },
        SetShouldRefreshViewTestComponent ({ commit }, data) {
            commit('SET_SHOULD_REFRESH_VIEW_TEST_COMPONENT', data)
        },
        SetShouldRefreshPatientTestsComponent ({ commit }, data) {
            commit('SET_SHOULD_REFRESH_PATIENT_TESTS_COMPONENT', data)
        }
    }
}